"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const pt_BR_1 = __importDefault(require("date-fns/locale/pt-BR")); //
const datePtBr = {
    name: 'pt-BR',
    locale: pt_BR_1.default
};
exports.default = datePtBr;
